import {BedTypes} from "@hosttools/core/models/listing.constant";
import type React from "react";
import {memo, useMemo} from "react";

import type {Bed} from "../type";

type Props = {
    bed: Bed;
};

const BedName: React.FC<Props> = ({bed}) => {
    const bedObj = useMemo(() => {
        return BedTypes.find(elem => elem.value === bed.bedType);
    }, [bed.bedType]);

    return <>{bedObj?.label ?? "Unknown"}</>;
};

export default memo(BedName);
